import { render } from "./ContactsDashboard.vue?vue&type=template&id=6a5e47b0"
import script from "./ContactsDashboard.vue?vue&type=script&lang=js"
export * from "./ContactsDashboard.vue?vue&type=script&lang=js"

import "./ContactsDashboard.vue?vue&type=style&index=0&id=6a5e47b0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__